module.exports = __webpack_public_path__ + "static/subheader-2.5f698d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/Home/subheader-2.png
// module id = 1137
// module chunks = 213534597649335